// extracted by mini-css-extract-plugin
module.exports = {"load_wrapper":"Loader_load_wrapper__3wuit","lds_ring":"Loader_lds_ring__2F7F9","lds-ring":"Loader_lds-ring__pJ-xD"};